export const defaultSkin = {
    lock: false,
    customer_id: 2,
    name_skin: "start skin configuration+es",
    main_css_path: "/assets/static/wl/nbn/main.css",
    editor: "admin",
    created_at: "2022-06-16T09:54:25Z",
    updated_at: "2022-06-16T09:54:25Z",
    loader: "MF",
    icon: "MF",
    color_text: "#FFFFFF",
    adv_color_text: "#6f1787",
    title: "Free Wi-Fi Zone",
    welcome_mess: "Бесплатная<br>Wi-Fi зона",
    welcome_mess_font: "25",
    bkg_color: "#00b956",
    bkg_repeat: false,
    img_mobile_path: "",
    img_desktop_path: "",
    img_point: "720",
    logo_1_position: "none",
    logo_1_path: "",
    logo_1_width: "",
    logo_2_path: "/assets/static/wl/mf/logo_ru.svg",
    logo_2_width: "150px",
    welcome_img: "/assets/static/wl/mf/bg_3.png",
    welcome_img_width: "270px",
    mask: false,
    mask_color: "",
    container_space: "flex-end",
    ch_box_spam: false,
    ch_box_rules: false,
    btn_border_px: "0px",
    btn_width: "280px",
    radius_btn: "25px",
    color_btn: "#6f1787",
    color_btn_h: "#6f1787",
    btn_font: "14",
    btn_brd_color: "#ffffff",
    btn_txt_color: "#ffffff",
    timer_style: "bar",
    mode_fonts: false,
    big_fonts: false,
    fonts_css_path: "",
    font_custom: "",
    font_name: "MegaFon Graphik LC Web",
    font_style: "normal",
    font_weight: "400",
    font_size: "14",
    lang: "ru,en",
    url_preview: null
}

export const MfLabelSkin = {
    adv_color_text: "#6f1787",
    big_fonts: false,
    bkg_color: "#00b956",
    bkg_repeat: false,
    btn_border_px: "0px",
    btn_brd_color: "#ffffff",
    btn_font: "14",
    btn_txt_color: "#ffffff",
    btn_width: "280px",
    ch_box_rules: true,
    ch_box_spam: false,
    color_btn: "#6f1787",
    color_btn_h: "#6f1787",
    color_text: "#FFFFFF",
    container_space: "flex-start",
    created_at: null,
    customer_id: 0,
    editor: "",
    font_custom: "font-family: \"MegaFon Graphik LC Web\"; font-weight: 300; font-style: normal; font-stretch: normal;",
    font_name: "MegaFon Graphik LC Web",
    font_size: "14",
    font_style: "normal",
    font_weight: "400",
    fonts_css_path: "/fonts/main.css",
    icon: "MF",
    id: 0,
    img_desktop_path: "",
    img_mobile_path: "",
    img_point: "720",
    lang: "ru,en",
    loader: "MF",
    lock: true,
    logo_1_path: "",
    logo_1_position: "none",
    logo_1_width: "",
    logo_2_path: "",
    logo_2_width: "150px",
    main_css_path: "/assets/static/wl/mf/main.css",
    mask: false,
    mask_color: "",
    mode_fonts: false,
    name_skin: "Label MegaFon",
    radius_btn: "25px",
    timer_style: "bar",
    title: "Megafon Free Wi-Fi Zone",
    updated_at: null,
    url_preview: null,
    welcome_img: "",
    welcome_img_width: "",
    welcome_mess: "Бесплатная<br>Wi-Fi зона",
    welcome_mess_font: "25"
}

export const NBNLabelSkin = {
    loader: "NBN",
    icon: "NBN",
    color_text: "#FFFFFF",
    adv_color_text: "#63b450",
    title: "Free Free Wi-Fi Zone",
    welcome_mess: "Бесплатная<br>Wi-Fi зона",
    welcome_mess_font: "25",
    bkg_color: "#ffffff",
    bkg_repeat: false,
    img_mobile_path: "/assets/static/wl/nbn/tochka-bg.png",
    img_desktop_path: "/assets/static/wl/nbn/tochka-bg.png",
    img_point: "720",
    logo_1_position: "mid",
    logo_1_path: "/assets/static/wl/nbn/NBN_Logo-simple-white.png",
    logo_1_width: "250px",
    logo_2_path: "",
    logo_2_width: "150px",
    welcome_img: "",
    welcome_img_width: "",
    mask: false,
    mask_color: "#00000080",
    container_space: "flex-end",
    ch_box_spam: false,
    ch_box_rules: true,
    btn_border_px: "0px",
    btn_width: "280px",
    radius_btn: "25px",
    color_btn: "#63B450c7",
    color_btn_h: "#63B450c7",
    btn_font: "14",
    btn_brd_color: "#ffffff",
    btn_txt_color: "#ffffff",
    timer_style: "bar",
    mode_fonts: false,
    big_fonts: false,
    fonts_css_path: "/fonts/main.css",
    font_custom: "",
    font_name: "TT Norms Pro",
    font_style: "normal",
    font_weight: "400",
    font_size: "14",
    lang: "ru,en,fr",
    url_preview: null
}

export const testTemplate = {
    id: 90,
    lock: true,
    customer_id: 689,
    created_at: "2021-09-28T06:30:03+03:00",
    updated_at: "2022-05-11T08:56:26+03:00",
    name: "HC lokomotive",
    comment: "call",
    author: "ktarasov",
    head: `<meta charset="UTF-8">
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <meta name="format-detection" content="telephone=yes">
    <link rel="stylesheet" type="text/css" href="/assets/static/lib/css/normalize.css">
    <link rel="stylesheet" href="/assets/static/lib/css/_reset.min.css">
    <link rel="stylesheet" href="/assets/static/lib/css/bootstrap.min.css"><link rel="shortcut icon" type="image/x-icon" href="/assets/static/wl/mf/favicon.ico">`,
    loader: `
// console.log()
`,
    css: `
@import url('/fonts/main.css');
.main-font-style {
    font-family: "Montserrat"; font-weight: 300; font-style: normal; font-stretch: normal;;
    color: #FFFFFF !important;
}
    

body,html {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-size: cover;
    background-position: center;
    margin: 0;
    min-height: 90vh;
    height: 100%;
    font-size: 14px;
    /* color: #606060; */
    text-align: center;
    overflow-x: hidden;
     background-color: #FFFFFF;  background-image: url('/assets/bcgr_109_bkg-locomotiv-kuban.png');
    background-repeat: no-repeat;
}
#root{
    height: 100%;
}
.preloading {
    z-index: 1;
}
#loading{
    position: absolute;
    top: 0;
    bottom: 0;
    /*left: 0;
    right: 0;*/
}

/* таймер обратного отсчета 'pie'*/
#timer {
    margin: 20px auto;
    width: 103px;
}

.pietimer {
    position:relative;
    font-size: 95px;
    width:1em;
    height:1em;
}
.pietimer > .percent {
    position: absolute;
    top: 0.4em;
    left: 0;
    width: 2.3em;
    font-size: 45px;
    text-align:center;
    display: none;
    color: #FFFFFF;
}
.pietimer > .slice {
    position:absolute;
    width:1em;
    height:1em;
    clip:rect(0px,1em,1em,0.5em);
}
.pietimer > .slice.gt50 {
    clip:rect(auto, auto, auto, auto);
}
.pietimer > .slice > .pie {
    border: 0.04em solid ;
    border-color: #FFFFFF !important;
    position:absolute;
    width:1em; /* 1 - (2 * border width) */
    height:1em; /* 1 - (2 * border width) */
    clip:rect(0em,0.5em,1em,0em);
    -moz-border-radius:0.5em;
    -webkit-border-radius:0.5em;
    border-radius:0.5em;
}
.pietimer > .slice > .pie.fill {
    -moz-transform:rotate(180deg) !important;
    -webkit-transform:rotate(180deg) !important;
    -o-transform:rotate(180deg) !important;
    transform:rotate(180deg) !important;
}
.pietimer.fill > .percent {
    display: none;
}
.pietimer.fill > .slice > .pie {
    border: transparent;
    background-color: white;
    width:1em;
    height:1em;
}
/* таймер обратного отсчета 'pie'. End */
select:focus,input,input:active:active,:focus{outline:none;box-shadow:none}
.form-group {
    display: block;
    margin-bottom: 15px;
}

.form-group input {
    padding: 0;
    display: none;
    height: initial;
    width: initial;
    margin-bottom: 0;
    cursor: pointer;
}

.form-group label {
    position: relative;
    cursor: pointer;
    display: inline-block;
    z-index: 0;
}

.form-group label:before {
    content: '';
    margin-right: 10px;
    display: inline-block;
    vertical-align: text-top;
    width: 20px;
    height: 20px;
    background: white;
}

.form-group input:checked + label:after {
    content: '';
    position: absolute;
    left: 12%;
    top: 50%;
    background: black;
    width: 2px;
    height: 2px;
    box-shadow:
            2px 0 0 black,
            4px 0 0 black,
            4px -2px 0 black,
            4px -4px 0 black,
            4px -6px 0 black,
            4px -8px 0 black;
    transform: rotate(45deg);
}
.hat {
    text-align: right;
}
.logo-hat-top {
    border: none;
    float: left;
    max-width: 150px;
    width: 128px !important;
    width: 120px;
    margin: 5px;
}

.logo-hat-center {
    width: 136px !important;
    width: 70vw;
    max-width: 300px;
}
.img-header-center {
    width:  136px !important;
    width: 90vw;
    max-width: 300px;
}
.logo-bot-center {
    margin: 10px auto;
    width: 105px !important;
    width: 150px;
    max-width: 250px;
}
.lang-inline {
    font-size: 17px;
    font-weight: 500;
    text-align: right;
    word-spacing: 10px;
}

.lang-tab {
    font-size: 14px;
    text-align: right;
    display: grid;
    margin-right: 3vw;
}

a {
    color: #FFFFFF;}
a:hover {
    color: #FFFFFF;}
a:active {
    color: #FFFFFF;}
a:visited {
    color: #FFFFFF;}

.content {
    border-radius: 0px;
    margin: 0 auto;
    margin-top: auto;
}
.header {
    display: flex;
    justify-content: space-between;
    padding: 21px 20px 0px 20px;
    height: 120px;
}
#container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}

.welcome-mess{
    /* display:none ; */
    font-weight: 700;
    line-height: 36px;
    font-size: 25px ; color: #63B450;\`) 
}
.segment-border {
    padding-bottom: 2vh;
}
.element-border {
    width: 280px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 10px;
    /*padding: 1px 5px;*/
    max-width: 90vw;
}
.nowrap {
    display: block;
    white-space: nowrap;
    color: #FFFFFF;
}
.btn {
    border-radius: 0px;
    border-color: #ffffff;
    font-size: 17px;
    font-weight: 500;
    color: #AB1732;
    cursor: pointer;
    padding: 18px;
    background-color: #ffffffFF;
    display:block;
    border-style: solid;
    border-width: 0px ;
    border-color: #FFFFFF;
    text-transform: uppercase;
}
.btn:hover {
    color: #AB1732;
    background: #ffffffFF;
}
p>a {
  color: #AB1732;
  padding: 18px;
  pointer-events: none;
}
#myProgress {
    margin-left: auto;
    margin-right: auto;
    max-width: 200px;
    width: 98%;
    position: relative;
    z-index: 1;
}
/* таймер обратного отсчета 'bar'. Start*/
#myBar {
    margin-left: auto;
    margin-right: auto;
    width: 0%;
    height: 50px;
    position: absolute;
    float: top;
    background-color: #ffffffFF;
    z-index: 2;
}
.circle-countdown {
	max-width: 80px;
	height: 80px;
}

.bar-countdown {
	position: relative;
	height: 35px;
	max-width: 300px;
	margin: 0 auto;
}
.progress-bar {
	height: 100%;
    background-color: white;
}
.bar-countdown-text {
	width: 200px;
	height: 22px;
	text-align: center;
	position: absolute;
	top: 50%;
	left: 50%;
	margin-top: -11px;
	margin-left: -100px;
}

#myBarText {
    font-size: 14px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 7px;
    padding-left: 20%;
    height: 50px;
    color: #000000;
    position: absolute;
    opacity: 0.9;
    z-index: 3;
}
/* таймер обратного отсчета 'bar'. End */
.insert-field {
    border-radius: 0px;
    border:0px;
    /*font-weight: bolder;*/
    font-size: 17px;
    color: #030303;
    cursor: pointer;
    padding: 8px;
    background-color: #fff;
    text-align: center;
}
.footer {
    padding: 10px 0px 10px;
    font-size: 10px;
    font-weight: 700;
    background-color: #124734;
    width: 100vw;
}

#content p.error {
    text-align: center;
    font-size: 9pt;
}
.hide__block {
\t\tmargin-bottom: 50px;
\t}
\t
\t.hide__block-text {
\t\ttext-transform: uppercase;
\t\ttext-align: center;
\t}
\t
\t.hide__block-text--first {
\t\tfont-size: 20px;
    color: rgb(255 255 255 / 0.5);
    font-weight: 500;
\t}
\t
\t.hide__block-text--sec {
\t\tline-height: 32px;
    font-size: 30px;
    color: rgb(255 255 255 / 0.5);
    font-weight: 500;
\t}
\t
\t.hide__block-text--big {
\t\tfont-size: 40px;
\t\tline-height: 42px;
\t\tcolor: rgb(255 255 255 / 0.5);
\t\tmargin: 10px 0;
\t\tfont-weight: bold;
\t}
@media screen and (min-width: 320px) {

    #myBar {
        height: 35px;
    }
    .element-border {
        max-width: 90vw;
    }
}
@media screen and (min-width: 370px) {

    .element-border {
        max-width: 350px;
    }
}
@media screen and (min-width: 640px){
  .header {
    padding: 86px 80px 0px 80px;
    height: 170px;
  }
}
@media screen and (min-width: 720px) {
    .element-border{
        max-width: 400px;
        width: calc(280px + 50px);
    }
    .welcome-mess {
        line-height: 40px;
        font-size: calc(25px + 10px);
    }
    .logo-hat-center {
        max-width: 400px;
    }
    .btn {
        font-size: calc(14px + 3px);
    }
}
@media screen and (min-width: 1024px) {
    .header {
        padding: 70px 115px 0px 115px;
        height: 200px;
    }
    .welcome-mess{
        line-height: 48px;
        font-size: calc(25px + 15px);;
    }
    .element-border{
        max-width: 500px;
        width: calc(280px + 100px)
    }
    .logo-hat-center {
        max-width: 600px;
    }
    .btn {
        font-size: calc(14px + 5px);
    }
}
@media screen and (min-width: 1440px) {

    .welcome-mess {
        line-height: 56px;
        font-size: calc(25px + 20px);
    }
    .element-border{
        max-width: 550px;
    }
}
`,
    welcome_block: `
    <div class="hat">
        <a id="head_lang_link" class="lang-inline s-lng-changer" data-changelng="ru" href="#" >Русский |</a>&nbsp
        <a id="head_lang_link" class="lang-inline s-lng-changer" data-changelng="en" href="#" >English |</a>&nbsp   </div>
    <div class="content" id="container">
        <div id="header" class="header segment-border">
            <img class="logo-hat-center" id="logo-top" src=/assets/logo_171_logo_free_loko.svg>
            <img id="img-header" class="img-header-center" src="/assets/logo_149_logo-locomotiv-kuban.svg">
        </div> <!-- end header -->
        <div id="content" class="segment-border">
            <div class="auth">  
                <button class="btn element-border" id="get_auth" data-id_phrase="btn_auth">Войти в Интернет</button>
            </div>
            <div id="welcome_actions" class="element-border"></div> 
        </div> <!-- end content -->
        <div id="footer" class="footer segment-border">
            <a class="footer_link" id="footer_link" href="/assets/static/img/wifire/ru/Offert.pdf" data-id_phrase="info_offert">Нажимая на кнопку, Вы соглашаетесь<br>
                <ins>с условиями предоставления услуги</ins>
            </a>
        </div> <!-- end footer -->
    </div><!-- end container --> 
`,
    authentication: `
    <div class="hat">
        <a id="head_lang_link" class="lang-inline s-lng-changer" data-changelng="ru" href="#" >Русский |</a>&nbsp
        <a id="head_lang_link" class="lang-inline s-lng-changer" data-changelng="en" href="#" >English |</a>&nbsp
    </div>
    <div class="content" id="container">
        <div id="header" class="header segment-border">
            <img class="logo-hat-center" id="logo-top" src=/assets/logo_171_logo_free_loko.svg>
            <img id="img-header" class="img-header-center" src="/assets/logo_149_logo-locomotiv-kuban.svg">
        </div> <!-- end header -->
        <div id="content" class="segment-border">
           <div id="ident">
                <div class="clear" data-id_phrase="select">Выберите метод Идентификации</div>
                <div class="call499">
                    <button class="btn element-border" id="get_call499" data-id_phrase="btn_call">Войти по звонку</button>
                </div>
            </div>
           <div id="timer"></div>
           <div id="auth_actions" class="element-border"></div>
        </div> <!-- end content -->
        <div id="footer" class="footer segment-border">
           <a class="footer_link" id="footer_link" href="/assets/static/img/wifire/ru/Offert.pdf" data-id_phrase="info_offert">Нажимая на кнопку, Вы соглашаетесь<br>
              <ins>с условиями предоставления услуги</ins>
           </a>
        </div> <!-- end footer -->
    </div><!-- end container --> 
`,
    title: "Free Wi-Fi Zone "
}

export const pollExample = {
    "id": 19,
    "customer_id": 1286,
    "question": "новый вопрос",
    "active": null,
    "opt": [
        {
            "id": 117,
            "poll_id": 19,
            "name": "новый ответ1"
        },
        {
            "id": 118,
            "poll_id": 19,
            "name": "новый ответ2"
        },
        {
            "id": 125,
            "poll_id": 19,
            "name": "test"
        },
        {
            "id": 128,
            "poll_id": 19,
            "name": "134"
        }
    ]
}


export const bannerExample = {
    "id": 1,
    "type": "image",
    "source_mobile": "/assets/imgBanner_181_test1.png",
    "source_desktop": "/assets/imgBanner_181_test1.png",
    "redirect_url": "https://pikabu.ru"
}